import { createFileRoute, redirect } from '@tanstack/react-router';

import { periodSearchSchema } from '@/features/workspace-usage';

/**
 * Kept for links made before spec 224 grouped this page under another entry:
 * the Usage page is the Spend tab of AI usage now. The search carries over, so a link that opened a form or a period still
 * does.
 */
export const Route = createFileRoute('/workspaces/$workspaceId/usage')({
  validateSearch: periodSearchSchema,
  beforeLoad: ({ params, search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/workspaces/$workspaceId/ai-usage/spend',
      params: { workspaceId: params.workspaceId },
      search: search,
      replace: true,
    });
  },
});
